import { Component, OnInit, OnDestroy } from '@angular/core';
import { LambdaFunctionService } from './../../../service/lambda-function.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pdf-download-popup',
  templateUrl: './pdf-download-popup.component.html',
  styleUrls: ['./pdf-download-popup.component.scss']
})
export class PdfDownloadPopupComponent implements OnInit, OnDestroy {

  pdfLink: string = '';
  pdfName: any = '';
  timer: any;
  text_arr = ['', 'Generating PDFs', 'Generating PDFs', 'Creating PDF Link'];
  text: string = '';
  private destroy$ = new Subject<void>();

  constructor(public lmbdaService: LambdaFunctionService) {}

  ngOnDestroy() {
    clearInterval(this.timer);
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.lmbdaService.pdfName.pipe(
      takeUntil(this.destroy$)
    ).subscribe((name) => {
      this.pdfName = name;
      this.text = `Fetching ${this.pdfName} Information`;
    });

    this.lmbdaService.pdf_popup.pipe(
      takeUntil(this.destroy$)
    ).subscribe((output) => {
      if (output) {
        this.pdfLink = '';
        this.text = this.text_arr[0];
        this.startTimer();
      } else {
        this.pdfLink = '';
        this.text = this.text_arr[0];
      }
    });

    this.lmbdaService.lambda_pdf.pipe(
      takeUntil(this.destroy$)
    ).subscribe((res) => {
      this.pdfLink = res;
    });
  }

  public startTimer() {
    let dots = '';
    let count = 0;
    this.timer = setInterval(() => {
      dots = dots + '.';
      this.text = this.text + dots;
      if (dots.length >= 3) {
        dots = '';
        count += 1;
        if (count >= 3) {
          count = 3;
        }
        this.text = this.text_arr[count];
      }
      if (this.pdfLink != '' && this.pdfLink != undefined) {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  public close() {
    $('.pdf-modal').css('display', 'none');
    this.pdfLink = '';
    this.text = this.text_arr[0];
    clearInterval(this.timer);
  }
}
